var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSheet = function SvgSheet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 142,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M181 57.665c0 56.276-36.673 115.564-85.876 65.452C45.921 73.005 0 113.941 0 57.665 0 1.39 39.63-15.86 73.938 15.542 108.245 46.946 181 1.39 181 57.665Z",
    fill: props.accentFill
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sheet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m117.253 20.614 9.495 11.472H111.6a1 1 0 0 1-1-1V12.602l6.651 8.01.002.002Z",
    fill: "none",
    stroke: "#363840",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 130.936V11.063h56.911l-3.311-4H128.005 54a3 3 0 0 0-3 3v121.873a3 3 0 0 0 3 3h74a3 3 0 0 0 3-3v-97.85l-4-4.817v101.667H55Z",
    fill: "#363840"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.9,
    y: 111.31,
    width: 31,
    height: 3.825,
    rx: 1.913,
    fill: "#363840",
    stroke: "#363840"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 81.151,
    width: 55,
    height: 3.825,
    rx: 1.913,
    fill: "#363840",
    stroke: "#363840"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 71.5,
    width: 55,
    height: 3.825,
    rx: 1.913,
    fill: "#363840",
    stroke: "#363840"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 61.849,
    width: 47,
    height: 3.825,
    rx: 1.913,
    fill: "#363840",
    stroke: "#363840"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 42.548,
    width: 31,
    height: 3.825,
    rx: 1.913,
    fill: "#363840",
    stroke: "#363840"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 32.897,
    width: 15,
    height: 3.825,
    rx: 1.913,
    fill: "#363840",
    stroke: "#363840"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sheet_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(51 7.063)",
    d: "M0 0h80v127.873H0z"
  })))));
};
export default SvgSheet;